import React from 'react';
import { Navigate } from 'react-router';

import { AliasMatching } from 'packages/limitedPartners/ui/AliasMatching';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';

const RouteBase = () => {
  return <AliasMatching />;
};

export const Route = () => {
  return (
    <RouteErrorBoundary
      fallback={({ message, showErrorToast }) => {
        showErrorToast(message);
        return <Navigate to="/" />;
      }}
    >
      <RouteBase />
    </RouteErrorBoundary>
  );
};
